import React, {ElementType, SVGProps} from 'react';

import {ReactComponent as ImportAddNew} from '../../assets/SVG/icon-add-new.svg';
import {ReactComponent as ImportAdminShieldSafe} from '../../assets/SVG/icon-admin-shield-safe.svg';
import {ReactComponent as ImportAmazonSagemaker} from '../../assets/SVG/icon-amazon-sagemaker.svg';
import {ReactComponent as ImportAudioVolume} from '../../assets/SVG/icon-audio-volume.svg';
import {ReactComponent as ImportAutomationRobotArm} from '../../assets/SVG/icon-automation-robot-arm.svg';
import {ReactComponent as ImportBack} from '../../assets/SVG/icon-back.svg';
import {ReactComponent as ImportBellNotifications} from '../../assets/SVG/icon-bell-notifications.svg';
import {ReactComponent as ImportBenchmarkSquare} from '../../assets/SVG/icon-benchmark-square.svg';
import {ReactComponent as ImportBlogReport} from '../../assets/SVG/icon-blog-report.svg';
import {ReactComponent as ImportCategoryMultimodal} from '../../assets/SVG/icon-category-multimodal.svg';
import {ReactComponent as ImportChartHorizontalBars} from '../../assets/SVG/icon-chart-horizontal-bars.svg';
import {ReactComponent as ImportChartPie} from '../../assets/SVG/icon-chart-pie.svg';
import {ReactComponent as ImportChartVerticalBars} from '../../assets/SVG/icon-chart-vertical-bars.svg';
import {ReactComponent as ImportCheckmark} from '../../assets/SVG/icon-checkmark.svg';
import {ReactComponent as ImportCheckmarkCircle} from '../../assets/SVG/icon-checkmark-circle.svg';
import {ReactComponent as ImportChevronBack} from '../../assets/SVG/icon-chevron-back.svg';
import {ReactComponent as ImportChevronDown} from '../../assets/SVG/icon-chevron-down.svg';
import {ReactComponent as ImportChevronNext} from '../../assets/SVG/icon-chevron-next.svg';
import {ReactComponent as ImportChevronUp} from '../../assets/SVG/icon-chevron-up.svg';
import {ReactComponent as ImportClose} from '../../assets/SVG/icon-close.svg';
import {ReactComponent as ImportCodeAlt} from '../../assets/SVG/icon-code-alt.svg';
import {ReactComponent as ImportContentFullWidth} from '../../assets/SVG/icon-content-full-width.svg';
import {ReactComponent as ImportContentNarrow} from '../../assets/SVG/icon-content-narrow.svg';
import {ReactComponent as ImportContentWide} from '../../assets/SVG/icon-content-wide.svg';
import {ReactComponent as ImportContractLeft} from '../../assets/SVG/icon-contract-left.svg';
import {ReactComponent as ImportCopy} from '../../assets/SVG/icon-copy.svg';
import {ReactComponent as ImportCreditCardPayment} from '../../assets/SVG/icon-credit-card-payment.svg';
import {ReactComponent as ImportCubeContainer} from '../../assets/SVG/icon-cube-container.svg';
import {ReactComponent as ImportDashboardBlackboard} from '../../assets/SVG/icon-dashboard-blackboard.svg';
import {ReactComponent as ImportDelete} from '../../assets/SVG/icon-delete.svg';
import {ReactComponent as ImportDiscordSocial} from '../../assets/SVG/icon-discord-social.svg';
import {ReactComponent as ImportDockerWhale} from '../../assets/SVG/icon-docker-whale.svg';
import {ReactComponent as ImportDocument} from '../../assets/SVG/icon-document.svg';
import {ReactComponent as ImportDocumentation} from '../../assets/SVG/icon-documentation.svg';
import {ReactComponent as ImportDownload} from '../../assets/SVG/icon-download.svg';
import {ReactComponent as ImportEducationAcademic} from '../../assets/SVG/icon-education-academic.svg';
import {ReactComponent as ImportEmailAt} from '../../assets/SVG/icon-email-at.svg';
import {ReactComponent as ImportEmailEnvelope} from '../../assets/SVG/icon-email-envelope.svg';
import {ReactComponent as ImportExpandRight} from '../../assets/SVG/icon-expand-right.svg';
import {ReactComponent as ImportFacebookSocial} from '../../assets/SVG/icon-facebook-social.svg';
import {ReactComponent as ImportFailed} from '../../assets/SVG/icon-failed.svg';
import {ReactComponent as ImportFlashBolt} from '../../assets/SVG/icon-flash-bolt.svg';
import {ReactComponent as ImportFolderAlt} from '../../assets/SVG/icon-folder-alt.svg';
import {ReactComponent as ImportFolderProject} from '../../assets/SVG/icon-folder-project.svg';
import {ReactComponent as ImportFolderProjectMove} from '../../assets/SVG/icon-folder-project-move.svg';
import {ReactComponent as ImportForumChatBubble} from '../../assets/SVG/icon-forum-chat-bubble.svg';
import {ReactComponent as ImportForwardNext} from '../../assets/SVG/icon-forward-next.svg';
import {ReactComponent as ImportFullScreenModeExpand} from '../../assets/SVG/icon-full-screen-mode-expand.svg';
import {ReactComponent as ImportGhostAgent} from '../../assets/SVG/icon-ghost-agent.svg';
import {ReactComponent as ImportGit} from '../../assets/SVG/icon-git.svg';
import {ReactComponent as ImportGithub} from '../../assets/SVG/icon-github.svg';
import {ReactComponent as ImportGroup} from '../../assets/SVG/icon-group.svg';
import {ReactComponent as ImportHeadset} from '../../assets/SVG/icon-headset.svg';
import {ReactComponent as ImportHeart} from '../../assets/SVG/icon-heart.svg';
import {ReactComponent as ImportHeartFilled} from '../../assets/SVG/icon-heart-filled.svg';
import {ReactComponent as ImportHelpAlt} from '../../assets/SVG/icon-help-alt.svg';
import {ReactComponent as ImportHideHidden} from '../../assets/SVG/icon-hide-hidden.svg';
import {ReactComponent as ImportHome} from '../../assets/SVG/icon-home.svg';
import {ReactComponent as ImportIdle} from '../../assets/SVG/icon-idle.svg';
import {ReactComponent as ImportIgnoreOutliers} from '../../assets/SVG/icon-ignore-outliers.svg';
import {ReactComponent as ImportImpersonateMaskAlt} from '../../assets/SVG/icon-impersonate-mask-alt.svg';
import {ReactComponent as ImportInfo} from '../../assets/SVG/icon-info.svg';
import {ReactComponent as ImportJobAutomation} from '../../assets/SVG/icon-job-automation.svg';
import {ReactComponent as ImportJobCalculator} from '../../assets/SVG/icon-job-calculator.svg';
import {ReactComponent as ImportJobProgramCode} from '../../assets/SVG/icon-job-program-code.svg';
import {ReactComponent as ImportJoyceTransformersLogo} from '../../assets/SVG/icon-joyce-transformers-logo.svg';
import {ReactComponent as ImportJoyceXgboostLogo} from '../../assets/SVG/icon-joyce-xgboost-logo.svg';
import {ReactComponent as ImportKerasLogo} from '../../assets/SVG/icon-keras-logo.svg';
import {ReactComponent as ImportKeyAdmin} from '../../assets/SVG/icon-key-admin.svg';
import {ReactComponent as ImportKeyAdminPrivate} from '../../assets/SVG/icon-key-admin-private.svg';
import {ReactComponent as ImportKubernetes} from '../../assets/SVG/icon-kubernetes.svg';
import {ReactComponent as ImportLanguages} from '../../assets/SVG/icon-languages.svg';
import {ReactComponent as ImportLaptopLocalComputer} from '../../assets/SVG/icon-laptop-local-computer.svg';
import {ReactComponent as ImportLightbulbInfo} from '../../assets/SVG/icon-lightbulb-info.svg';
import {ReactComponent as ImportLinkAlt} from '../../assets/SVG/icon-link-alt.svg';
import {ReactComponent as ImportLinkedinSocial} from '../../assets/SVG/icon-linkedin-social.svg';
import {ReactComponent as ImportList} from '../../assets/SVG/icon-list.svg';
import {ReactComponent as ImportListBullets} from '../../assets/SVG/icon-list-bullets.svg';
import {ReactComponent as ImportLoading} from '../../assets/SVG/icon-loading.svg';
import {ReactComponent as ImportLockClosed} from '../../assets/SVG/icon-lock-closed.svg';
import {ReactComponent as ImportLockOpen} from '../../assets/SVG/icon-lock-open.svg';
import {ReactComponent as ImportLogOut} from '../../assets/SVG/icon-log-out.svg';
import {ReactComponent as ImportLogoColab} from '../../assets/SVG/icon-logo-colab.svg';
import {ReactComponent as ImportMagicWandStar} from '../../assets/SVG/icon-magic-wand-star.svg';
import {ReactComponent as ImportMagicWandStick} from '../../assets/SVG/icon-magic-wand-stick.svg';
import {ReactComponent as ImportMicrophoneAudio} from '../../assets/SVG/icon-microphone-audio.svg';
import {ReactComponent as ImportMinimizeMode} from '../../assets/SVG/icon-minimize-mode.svg';
import {ReactComponent as ImportModel} from '../../assets/SVG/icon-model.svg';
import {ReactComponent as ImportMusicAudio} from '../../assets/SVG/icon-music-audio.svg';
import {ReactComponent as ImportOpenNewTab} from '../../assets/SVG/icon-open-new-tab.svg';
import {ReactComponent as ImportOrchestrationLaunch} from '../../assets/SVG/icon-orchestration-launch.svg';
import {ReactComponent as ImportOrganizationCorporate} from '../../assets/SVG/icon-organization-corporate.svg';
import {ReactComponent as ImportOverflowHorizontal} from '../../assets/SVG/icon-overflow-horizontal.svg';
import {ReactComponent as ImportPause} from '../../assets/SVG/icon-pause.svg';
import {ReactComponent as ImportPaused} from '../../assets/SVG/icon-paused.svg';
import {ReactComponent as ImportPencilEdit} from '../../assets/SVG/icon-pencil-edit.svg';
import {ReactComponent as ImportPhoto} from '../../assets/SVG/icon-photo.svg';
import {ReactComponent as ImportPlay} from '../../assets/SVG/icon-play.svg';
import {ReactComponent as ImportPrivacyOpen} from '../../assets/SVG/icon-privacy-open.svg';
import {ReactComponent as ImportPythonLogo} from '../../assets/SVG/icon-python-logo.svg';
import {ReactComponent as ImportPytorchLightningLogo} from '../../assets/SVG/icon-pytorch-lightning-logo.svg';
import {ReactComponent as ImportPytorchLogo} from '../../assets/SVG/icon-pytorch-logo.svg';
import {ReactComponent as ImportQueue} from '../../assets/SVG/icon-queue.svg';
import {ReactComponent as ImportQueued} from '../../assets/SVG/icon-queued.svg';
import {ReactComponent as ImportRandomizeAlt} from '../../assets/SVG/icon-randomize-alt.svg';
import {ReactComponent as ImportRecentClock} from '../../assets/SVG/icon-recent-clock.svg';
import {ReactComponent as ImportRedditSocial} from '../../assets/SVG/icon-reddit-social.svg';
import {ReactComponent as ImportReport} from '../../assets/SVG/icon-report.svg';
import {ReactComponent as ImportRetry} from '../../assets/SVG/icon-retry.svg';
import {ReactComponent as ImportRobotServiceMember} from '../../assets/SVG/icon-robot-service-member.svg';
import {ReactComponent as ImportRocketLaunch} from '../../assets/SVG/icon-rocket-launch.svg';
import {ReactComponent as ImportRun} from '../../assets/SVG/icon-run.svg';
import {ReactComponent as ImportRunningRepeat} from '../../assets/SVG/icon-running-repeat.svg';
import {ReactComponent as ImportScikitLogo} from '../../assets/SVG/icon-scikit-logo.svg';
import {ReactComponent as ImportSearch} from '../../assets/SVG/icon-search.svg';
import {ReactComponent as ImportSettings} from '../../assets/SVG/icon-settings.svg';
import {ReactComponent as ImportSettingsParameters} from '../../assets/SVG/icon-settings-parameters.svg';
import {ReactComponent as ImportShareExport} from '../../assets/SVG/icon-share-export.svg';
import {ReactComponent as ImportShareWith} from '../../assets/SVG/icon-share-with.svg';
import {ReactComponent as ImportShieldRemove} from '../../assets/SVG/icon-shield-remove.svg';
import {ReactComponent as ImportShowVisible} from '../../assets/SVG/icon-show-visible.svg';
import {ReactComponent as ImportSmoothing} from '../../assets/SVG/icon-smoothing.svg';
import {ReactComponent as ImportSort} from '../../assets/SVG/icon-sort.svg';
import {ReactComponent as ImportSortAscending} from '../../assets/SVG/icon-sort-ascending.svg';
import {ReactComponent as ImportSortDescending} from '../../assets/SVG/icon-sort-descending.svg';
import {ReactComponent as ImportStar} from '../../assets/SVG/icon-star.svg';
import {ReactComponent as ImportStarFilled} from '../../assets/SVG/icon-star-filled.svg';
import {ReactComponent as ImportStop} from '../../assets/SVG/icon-stop.svg';
import {ReactComponent as ImportStopped} from '../../assets/SVG/icon-stopped.svg';
import {ReactComponent as ImportSweepBayes} from '../../assets/SVG/icon-sweep-bayes.svg';
import {ReactComponent as ImportSweepGrid} from '../../assets/SVG/icon-sweep-grid.svg';
import {ReactComponent as ImportSweepRandomSearch} from '../../assets/SVG/icon-sweep-random-search.svg';
import {ReactComponent as ImportSweepsAlt} from '../../assets/SVG/icon-sweeps-alt.svg';
import {ReactComponent as ImportSweepsBroom} from '../../assets/SVG/icon-sweeps-broom.svg';
import {ReactComponent as ImportSweepsBroomAlt} from '../../assets/SVG/icon-sweeps-broom-alt.svg';
import {ReactComponent as ImportSystem} from '../../assets/SVG/icon-system.svg';
import {ReactComponent as ImportSystemChip} from '../../assets/SVG/icon-system-chip.svg';
import {ReactComponent as ImportSystemChipAlt} from '../../assets/SVG/icon-system-chip-alt.svg';
import {ReactComponent as ImportTable} from '../../assets/SVG/icon-table.svg';
import {ReactComponent as ImportTag} from '../../assets/SVG/icon-tag.svg';
import {ReactComponent as ImportTensorflowLogo} from '../../assets/SVG/icon-tensorflow-logo.svg';
import {ReactComponent as ImportTextLanguage} from '../../assets/SVG/icon-text-language.svg';
import {ReactComponent as ImportTextLanguageAlt} from '../../assets/SVG/icon-text-language-alt.svg';
import {ReactComponent as ImportTriggerAlt} from '../../assets/SVG/icon-trigger-alt.svg';
import {ReactComponent as ImportTwitter} from '../../assets/SVG/icon-twitter.svg';
import {ReactComponent as ImportUndeterminateVisibility} from '../../assets/SVG/icon-undeterminate-visibility.svg';
import {ReactComponent as ImportUserProfilePersonal} from '../../assets/SVG/icon-user-profile-personal.svg';
import {ReactComponent as ImportVersionsLayers} from '../../assets/SVG/icon-versions-layers.svg';
import {ReactComponent as ImportVertexGCP} from '../../assets/SVG/icon-vertex-gcp.svg';
import {ReactComponent as ImportVideoPlay} from '../../assets/SVG/icon-video-play.svg';
import {ReactComponent as ImportWandb} from '../../assets/SVG/icon-wandb.svg';
import {ReactComponent as ImportWarning} from '../../assets/SVG/icon-warning.svg';
import {ReactComponent as ImportXAxis} from '../../assets/SVG/icon-x-axis.svg';
import {ReactComponent as ImportYoutubeSocial} from '../../assets/SVG/icon-youtube-social.svg';
import {IconName} from './types';

type SVGIconProps = SVGProps<SVGElement>;

// The natural width/height in our SVG files is 24x24 when the design team provides them.
// However, the design team would also like the default icon size to be 20x20 in our app,
// so we override those attributes for the icon exports.
const updateIconProps = (props: SVGIconProps) => {
  return {
    width: 20,
    height: 20,
    ...props,
  };
};
export const IconAddNew = (props: SVGIconProps) => (
  <ImportAddNew {...updateIconProps(props)} />
);
export const IconAdminShieldSafe = (props: SVGIconProps) => (
  <ImportAdminShieldSafe {...updateIconProps(props)} />
);
export const IconAmazonSagemaker = (props: SVGIconProps) => (
  <ImportAmazonSagemaker {...updateIconProps(props)} />
);
export const IconAudioVolume = (props: SVGIconProps) => (
  <ImportAudioVolume {...updateIconProps(props)} />
);
export const IconAutomationRobotArm = (props: SVGIconProps) => (
  <ImportAutomationRobotArm {...updateIconProps(props)} />
);
export const IconBack = (props: SVGIconProps) => (
  <ImportBack {...updateIconProps(props)} />
);
export const IconBellNotifications = (props: SVGIconProps) => (
  <ImportBellNotifications {...updateIconProps(props)} />
);
export const IconBenchmarkSquare = (props: SVGIconProps) => (
  <ImportBenchmarkSquare {...updateIconProps(props)} />
);
export const IconBlogReport = (props: SVGIconProps) => (
  <ImportBlogReport {...updateIconProps(props)} />
);
export const IconCategoryMultimodal = (props: SVGIconProps) => (
  <ImportCategoryMultimodal {...updateIconProps(props)} />
);
export const IconChartHorizontalBars = (props: SVGIconProps) => (
  <ImportChartHorizontalBars {...updateIconProps(props)} />
);
export const IconChartPie = (props: SVGIconProps) => (
  <ImportChartPie {...updateIconProps(props)} />
);
export const IconChartVerticalBars = (props: SVGIconProps) => (
  <ImportChartVerticalBars {...updateIconProps(props)} />
);
export const IconCheckmark = (props: SVGIconProps) => (
  <ImportCheckmark {...updateIconProps(props)} />
);
export const IconCheckmarkCircle = (props: SVGIconProps) => (
  <ImportCheckmarkCircle {...updateIconProps(props)} />
);
export const IconChevronBack = (props: SVGIconProps) => (
  <ImportChevronBack {...updateIconProps(props)} />
);
export const IconChevronDown = (props: SVGIconProps) => (
  <ImportChevronDown {...updateIconProps(props)} />
);
export const IconChevronNext = (props: SVGIconProps) => (
  <ImportChevronNext {...updateIconProps(props)} />
);
export const IconChevronUp = (props: SVGIconProps) => (
  <ImportChevronUp {...updateIconProps(props)} />
);
export const IconClose = (props: SVGIconProps) => (
  <ImportClose {...updateIconProps(props)} />
);
export const IconCodeAlt = (props: SVGIconProps) => (
  <ImportCodeAlt {...updateIconProps(props)} />
);
export const IconContentFullWidth = (props: SVGIconProps) => (
  <ImportContentFullWidth {...updateIconProps(props)} />
);
export const IconContentNarrow = (props: SVGIconProps) => (
  <ImportContentNarrow {...updateIconProps(props)} />
);
export const IconContentWide = (props: SVGIconProps) => (
  <ImportContentWide {...updateIconProps(props)} />
);
export const IconContractLeft = (props: SVGIconProps) => (
  <ImportContractLeft {...updateIconProps(props)} />
);
export const IconCopy = (props: SVGIconProps) => (
  <ImportCopy {...updateIconProps(props)} />
);
export const IconCreditCardPayment = (props: SVGIconProps) => (
  <ImportCreditCardPayment {...updateIconProps(props)} />
);
export const IconCubeContainer = (props: SVGIconProps) => (
  <ImportCubeContainer {...updateIconProps(props)} />
);
export const IconDashboardBlackboard = (props: SVGIconProps) => (
  <ImportDashboardBlackboard {...updateIconProps(props)} />
);
export const IconDelete = (props: SVGIconProps) => (
  <ImportDelete {...updateIconProps(props)} />
);
export const IconDiscordSocial = (props: SVGIconProps) => (
  <ImportDiscordSocial {...updateIconProps(props)} />
);
export const IconDockerWhale = (props: SVGIconProps) => (
  <ImportDockerWhale {...updateIconProps(props)} />
);
export const IconDocument = (props: SVGIconProps) => (
  <ImportDocument {...updateIconProps(props)} />
);
export const IconDocumentation = (props: SVGIconProps) => (
  <ImportDocumentation {...updateIconProps(props)} />
);
export const IconDownload = (props: SVGIconProps) => (
  <ImportDownload {...updateIconProps(props)} />
);
export const IconEducationAcademic = (props: SVGIconProps) => (
  <ImportEducationAcademic {...updateIconProps(props)} />
);
export const IconEmailAt = (props: SVGIconProps) => (
  <ImportEmailAt {...updateIconProps(props)} />
);
export const IconEmailEnvelope = (props: SVGIconProps) => (
  <ImportEmailEnvelope {...updateIconProps(props)} />
);
export const IconExpandRight = (props: SVGIconProps) => (
  <ImportExpandRight {...updateIconProps(props)} />
);
export const IconFacebookSocial = (props: SVGIconProps) => (
  <ImportFacebookSocial {...updateIconProps(props)} />
);
export const IconFailed = (props: SVGIconProps) => (
  <ImportFailed {...updateIconProps(props)} />
);
export const IconFlashBolt = (props: SVGIconProps) => (
  <ImportFlashBolt {...updateIconProps(props)} />
);
export const IconFolderAlt = (props: SVGIconProps) => (
  <ImportFolderAlt {...updateIconProps(props)} />
);
export const IconFolderProject = (props: SVGIconProps) => (
  <ImportFolderProject {...updateIconProps(props)} />
);
export const IconFolderProjectMove = (props: SVGIconProps) => (
  <ImportFolderProjectMove {...updateIconProps(props)} />
);
export const IconForumChatBubble = (props: SVGIconProps) => (
  <ImportForumChatBubble {...updateIconProps(props)} />
);
export const IconForwardNext = (props: SVGIconProps) => (
  <ImportForwardNext {...updateIconProps(props)} />
);
export const IconFullScreenModeExpand = (props: SVGIconProps) => (
  <ImportFullScreenModeExpand {...updateIconProps(props)} />
);
export const IconGhostAgent = (props: SVGIconProps) => (
  <ImportGhostAgent {...updateIconProps(props)} />
);
export const IconGit = (props: SVGIconProps) => (
  <ImportGit {...updateIconProps(props)} />
);
export const IconGithub = (props: SVGIconProps) => (
  <ImportGithub {...updateIconProps(props)} />
);
export const IconGroup = (props: SVGIconProps) => (
  <ImportGroup {...updateIconProps(props)} />
);
export const IconHeadset = (props: SVGIconProps) => (
  <ImportHeadset {...updateIconProps(props)} />
);
export const IconHeart = (props: SVGIconProps) => (
  <ImportHeart {...updateIconProps(props)} />
);
export const IconHeartFilled = (props: SVGIconProps) => (
  <ImportHeartFilled {...updateIconProps(props)} />
);
export const IconHelpAlt = (props: SVGIconProps) => (
  <ImportHelpAlt {...updateIconProps(props)} />
);
export const IconHideHidden = (props: SVGIconProps) => (
  <ImportHideHidden {...updateIconProps(props)} />
);
export const IconHome = (props: SVGIconProps) => (
  <ImportHome {...updateIconProps(props)} />
);
export const IconIdle = (props: SVGIconProps) => (
  <ImportIdle {...updateIconProps(props)} />
);
export const IconIgnoreOutliers = (props: SVGIconProps) => (
  <ImportIgnoreOutliers {...updateIconProps(props)} />
);
export const IconImpersonateMaskAlt = (props: SVGIconProps) => (
  <ImportImpersonateMaskAlt {...updateIconProps(props)} />
);
export const IconInfo = (props: SVGIconProps) => (
  <ImportInfo {...updateIconProps(props)} />
);
export const IconJobAutomation = (props: SVGIconProps) => (
  <ImportJobAutomation {...updateIconProps(props)} />
);
export const IconJobCalculator = (props: SVGIconProps) => (
  <ImportJobCalculator {...updateIconProps(props)} />
);
export const IconJobProgramCode = (props: SVGIconProps) => (
  <ImportJobProgramCode {...updateIconProps(props)} />
);
export const IconJoyceTransformersLogo = (props: SVGIconProps) => (
  <ImportJoyceTransformersLogo {...updateIconProps(props)} />
);
export const IconJoyceXgboostLogo = (props: SVGIconProps) => (
  <ImportJoyceXgboostLogo {...updateIconProps(props)} />
);
export const IconKerasLogo = (props: SVGIconProps) => (
  <ImportKerasLogo {...updateIconProps(props)} />
);
export const IconKeyAdmin = (props: SVGIconProps) => (
  <ImportKeyAdmin {...updateIconProps(props)} />
);
export const IconKeyAdminPrivate = (props: SVGIconProps) => (
  <ImportKeyAdminPrivate {...updateIconProps(props)} />
);
export const IconKubernetes = (props: SVGIconProps) => (
  <ImportKubernetes {...updateIconProps(props)} />
);
export const IconLanguages = (props: SVGIconProps) => (
  <ImportLanguages {...updateIconProps(props)} />
);
export const IconLaptopLocalComputer = (props: SVGIconProps) => (
  <ImportLaptopLocalComputer {...updateIconProps(props)} />
);
export const IconLightbulbInfo = (props: SVGIconProps) => (
  <ImportLightbulbInfo {...updateIconProps(props)} />
);
export const IconLinkAlt = (props: SVGIconProps) => (
  <ImportLinkAlt {...updateIconProps(props)} />
);
export const IconLinkedinSocial = (props: SVGIconProps) => (
  <ImportLinkedinSocial {...updateIconProps(props)} />
);
export const IconList = (props: SVGIconProps) => (
  <ImportList {...updateIconProps(props)} />
);
export const IconListBullets = (props: SVGIconProps) => (
  <ImportListBullets {...updateIconProps(props)} />
);
export const IconLoading = (props: SVGIconProps) => (
  <ImportLoading {...updateIconProps(props)} />
);
export const IconLockClosed = (props: SVGIconProps) => (
  <ImportLockClosed {...updateIconProps(props)} />
);
export const IconLockOpen = (props: SVGIconProps) => (
  <ImportLockOpen {...updateIconProps(props)} />
);
export const IconLogOut = (props: SVGIconProps) => (
  <ImportLogOut {...updateIconProps(props)} />
);
export const IconLogoColab = (props: SVGIconProps) => (
  <ImportLogoColab {...updateIconProps(props)} />
);
export const IconMagicWandStar = (props: SVGIconProps) => (
  <ImportMagicWandStar {...updateIconProps(props)} />
);
export const IconMagicWandStick = (props: SVGIconProps) => (
  <ImportMagicWandStick {...updateIconProps(props)} />
);
export const IconMicrophoneAudio = (props: SVGIconProps) => (
  <ImportMicrophoneAudio {...updateIconProps(props)} />
);
export const IconMinimizeMode = (props: SVGIconProps) => (
  <ImportMinimizeMode {...updateIconProps(props)} />
);
export const IconModel = (props: SVGIconProps) => (
  <ImportModel {...updateIconProps(props)} />
);
export const IconMusicAudio = (props: SVGIconProps) => (
  <ImportMusicAudio {...updateIconProps(props)} />
);
export const IconOpenNewTab = (props: SVGIconProps) => (
  <ImportOpenNewTab {...updateIconProps(props)} />
);
export const IconOrchestrationLaunch = (props: SVGIconProps) => (
  <ImportOrchestrationLaunch {...updateIconProps(props)} />
);
export const IconOrganizationCorporate = (props: SVGIconProps) => (
  <ImportOrganizationCorporate {...updateIconProps(props)} />
);
export const IconOverflowHorizontal = (props: SVGIconProps) => (
  <ImportOverflowHorizontal {...updateIconProps(props)} />
);
export const IconPause = (props: SVGIconProps) => (
  <ImportPause {...updateIconProps(props)} />
);
export const IconPaused = (props: SVGIconProps) => (
  <ImportPaused {...updateIconProps(props)} />
);
export const IconPencilEdit = (props: SVGIconProps) => (
  <ImportPencilEdit {...updateIconProps(props)} />
);
export const IconPhoto = (props: SVGIconProps) => (
  <ImportPhoto {...updateIconProps(props)} />
);
export const IconPlay = (props: SVGIconProps) => (
  <ImportPlay {...updateIconProps(props)} />
);
export const IconPrivacyOpen = (props: SVGIconProps) => (
  <ImportPrivacyOpen {...updateIconProps(props)} />
);
export const IconPythonLogo = (props: SVGIconProps) => (
  <ImportPythonLogo {...updateIconProps(props)} />
);
export const IconPytorchLightningLogo = (props: SVGIconProps) => (
  <ImportPytorchLightningLogo {...updateIconProps(props)} />
);
export const IconPytorchLogo = (props: SVGIconProps) => (
  <ImportPytorchLogo {...updateIconProps(props)} />
);
export const IconQueue = (props: SVGIconProps) => (
  <ImportQueue {...updateIconProps(props)} />
);
export const IconQueued = (props: SVGIconProps) => (
  <ImportQueued {...updateIconProps(props)} />
);
export const IconRandomizeAlt = (props: SVGIconProps) => (
  <ImportRandomizeAlt {...updateIconProps(props)} />
);
export const IconRecentClock = (props: SVGIconProps) => (
  <ImportRecentClock {...updateIconProps(props)} />
);
export const IconRedditSocial = (props: SVGIconProps) => (
  <ImportRedditSocial {...updateIconProps(props)} />
);
export const IconReport = (props: SVGIconProps) => (
  <ImportReport {...updateIconProps(props)} />
);
export const IconRetry = (props: SVGIconProps) => (
  <ImportRetry {...updateIconProps(props)} />
);
export const IconRobotServiceMember = (props: SVGIconProps) => (
  <ImportRobotServiceMember {...updateIconProps(props)} />
);
export const IconRocketLaunch = (props: SVGIconProps) => (
  <ImportRocketLaunch {...updateIconProps(props)} />
);
export const IconRun = (props: SVGIconProps) => (
  <ImportRun {...updateIconProps(props)} />
);
export const IconRunningRepeat = (props: SVGIconProps) => (
  <ImportRunningRepeat {...updateIconProps(props)} />
);
export const IconScikitLogo = (props: SVGIconProps) => (
  <ImportScikitLogo {...updateIconProps(props)} />
);
export const IconSearch = (props: SVGIconProps) => (
  <ImportSearch {...updateIconProps(props)} />
);
export const IconSettings = (props: SVGIconProps) => (
  <ImportSettings {...updateIconProps(props)} />
);
export const IconSettingsParameters = (props: SVGIconProps) => (
  <ImportSettingsParameters {...updateIconProps(props)} />
);
export const IconShareExport = (props: SVGIconProps) => (
  <ImportShareExport {...updateIconProps(props)} />
);
export const IconShareWith = (props: SVGIconProps) => (
  <ImportShareWith {...updateIconProps(props)} />
);
export const IconShieldRemove = (props: SVGIconProps) => (
  <ImportShieldRemove {...updateIconProps(props)} />
);
export const IconShowVisible = (props: SVGIconProps) => (
  <ImportShowVisible {...updateIconProps(props)} />
);
export const IconSmoothing = (props: SVGIconProps) => (
  <ImportSmoothing {...updateIconProps(props)} />
);
export const IconSort = (props: SVGIconProps) => (
  <ImportSort {...updateIconProps(props)} />
);
export const IconSortAscending = (props: SVGIconProps) => (
  <ImportSortAscending {...updateIconProps(props)} />
);
export const IconSortDescending = (props: SVGIconProps) => (
  <ImportSortDescending {...updateIconProps(props)} />
);
export const IconStar = (props: SVGIconProps) => (
  <ImportStar {...updateIconProps(props)} />
);
export const IconStarFilled = (props: SVGIconProps) => (
  <ImportStarFilled {...updateIconProps(props)} />
);
export const IconStop = (props: SVGIconProps) => (
  <ImportStop {...updateIconProps(props)} />
);
export const IconStopped = (props: SVGIconProps) => (
  <ImportStopped {...updateIconProps(props)} />
);
export const IconSweepBayes = (props: SVGIconProps) => (
  <ImportSweepBayes {...updateIconProps(props)} />
);
export const IconSweepGrid = (props: SVGIconProps) => (
  <ImportSweepGrid {...updateIconProps(props)} />
);
export const IconSweepRandomSearch = (props: SVGIconProps) => (
  <ImportSweepRandomSearch {...updateIconProps(props)} />
);
export const IconSweepsAlt = (props: SVGIconProps) => (
  <ImportSweepsAlt {...updateIconProps(props)} />
);
export const IconSweepsBroom = (props: SVGIconProps) => (
  <ImportSweepsBroom {...updateIconProps(props)} />
);
export const IconSweepsBroomAlt = (props: SVGIconProps) => (
  <ImportSweepsBroomAlt {...updateIconProps(props)} />
);
export const IconSystem = (props: SVGIconProps) => (
  <ImportSystem {...updateIconProps(props)} />
);
export const IconSystemChip = (props: SVGIconProps) => (
  <ImportSystemChip {...updateIconProps(props)} />
);
export const IconSystemChipAlt = (props: SVGIconProps) => (
  <ImportSystemChipAlt {...updateIconProps(props)} />
);
export const IconTable = (props: SVGIconProps) => (
  <ImportTable {...updateIconProps(props)} />
);
export const IconTag = (props: SVGIconProps) => (
  <ImportTag {...updateIconProps(props)} />
);
export const IconTensorflowLogo = (props: SVGIconProps) => (
  <ImportTensorflowLogo {...updateIconProps(props)} />
);
export const IconTextLanguage = (props: SVGIconProps) => (
  <ImportTextLanguage {...updateIconProps(props)} />
);
export const IconTextLanguageAlt = (props: SVGIconProps) => (
  <ImportTextLanguageAlt {...updateIconProps(props)} />
);
export const IconTriggerAlt = (props: SVGIconProps) => (
  <ImportTriggerAlt {...updateIconProps(props)} />
);
export const IconTwitter = (props: SVGIconProps) => (
  <ImportTwitter {...updateIconProps(props)} />
);
export const IconUndeterminateVisibility = (props: SVGIconProps) => (
  <ImportUndeterminateVisibility {...updateIconProps(props)} />
);
export const IconUserProfilePersonal = (props: SVGIconProps) => (
  <ImportUserProfilePersonal {...updateIconProps(props)} />
);
export const IconVersionsLayers = (props: SVGIconProps) => (
  <ImportVersionsLayers {...updateIconProps(props)} />
);
export const IconVertexGCP = (props: SVGIconProps) => (
  <ImportVertexGCP {...updateIconProps(props)} />
);
export const IconVideoPlay = (props: SVGIconProps) => (
  <ImportVideoPlay {...updateIconProps(props)} />
);
export const IconWandb = (props: SVGIconProps) => (
  <ImportWandb {...updateIconProps(props)} />
);
export const IconWarning = (props: SVGIconProps) => (
  <ImportWarning {...updateIconProps(props)} />
);
export const IconXAxis = (props: SVGIconProps) => (
  <ImportXAxis {...updateIconProps(props)} />
);
export const IconYoutubeSocial = (props: SVGIconProps) => (
  <ImportYoutubeSocial {...updateIconProps(props)} />
);

const ICON_NAME_TO_ICON: Record<IconName, ElementType> = {
  'add-new': IconAddNew,
  'admin-shield-safe': IconAdminShieldSafe,
  'amazon-sagemaker': IconAmazonSagemaker,
  'audio-volume': IconAudioVolume,
  'automation-robot-arm': IconAutomationRobotArm,
  back: IconBack,
  'bell-notifications': IconBellNotifications,
  'benchmark-square': IconBenchmarkSquare,
  'blog-report': IconBlogReport,
  'category-multimodal': IconCategoryMultimodal,
  'chart-horizontal-bars': IconChartHorizontalBars,
  'chart-pie': IconChartPie,
  'chart-vertical-bars': IconChartVerticalBars,
  checkmark: IconCheckmark,
  'checkmark-circle': IconCheckmarkCircle,
  'chevron-back': IconChevronBack,
  'chevron-down': IconChevronDown,
  'chevron-next': IconChevronNext,
  'chevron-up': IconChevronUp,
  close: IconClose,
  'code-alt': IconCodeAlt,
  'content-full-width': IconContentFullWidth,
  'content-narrow': IconContentNarrow,
  'content-wide': IconContentWide,
  'contract-left': IconContractLeft,
  copy: IconCopy,
  'credit-card-payment': IconCreditCardPayment,
  'cube-container': IconCubeContainer,
  'dashboard-blackboard': IconDashboardBlackboard,
  delete: IconDelete,
  'discord-social': IconDiscordSocial,
  'docker-whale': IconDockerWhale,
  document: IconDocument,
  documentation: IconDocumentation,
  download: IconDownload,
  'education-academic': IconEducationAcademic,
  'email-at': IconEmailAt,
  'email-envelope': IconEmailEnvelope,
  'expand-right': IconExpandRight,
  'facebook-social': IconFacebookSocial,
  failed: IconFailed,
  'flash-bolt': IconFlashBolt,
  'folder-alt': IconFolderAlt,
  'folder-project': IconFolderProject,
  'folder-project-move': IconFolderProjectMove,
  'forum-chat-bubble': IconForumChatBubble,
  'forward-next': IconForwardNext,
  'full-screen-mode-expand': IconFullScreenModeExpand,
  'ghost-agent': IconGhostAgent,
  git: IconGit,
  github: IconGithub,
  group: IconGroup,
  headset: IconHeadset,
  heart: IconHeart,
  'heart-filled': IconHeartFilled,
  'help-alt': IconHelpAlt,
  'hide-hidden': IconHideHidden,
  home: IconHome,
  idle: IconIdle,
  'ignore-outliers': IconIgnoreOutliers,
  'impersonate-mask-alt': IconImpersonateMaskAlt,
  info: IconInfo,
  'job-automation': IconJobAutomation,
  'job-calculator': IconJobCalculator,
  'job-program-code': IconJobProgramCode,
  'joyce-transformers-logo': IconJoyceTransformersLogo,
  'joyce-xgboost-logo': IconJoyceXgboostLogo,
  'keras-logo': IconKerasLogo,
  'key-admin': IconKeyAdmin,
  'key-admin-private': IconKeyAdminPrivate,
  kubernetes: IconKubernetes,
  languages: IconLanguages,
  'laptop-local-computer': IconLaptopLocalComputer,
  'lightbulb-info': IconLightbulbInfo,
  'link-alt': IconLinkAlt,
  'linkedin-social': IconLinkedinSocial,
  list: IconList,
  'list-bullets': IconListBullets,
  loading: IconLoading,
  'lock-closed': IconLockClosed,
  'lock-open': IconLockOpen,
  'log-out': IconLogOut,
  'logo-colab': IconLogoColab,
  'magic-wand-star': IconMagicWandStar,
  'magic-wand-stick': IconMagicWandStick,
  'microphone-audio': IconMicrophoneAudio,
  'minimize-mode': IconMinimizeMode,
  model: IconModel,
  'music-audio': IconMusicAudio,
  'open-new-tab': IconOpenNewTab,
  'orchestration-launch': IconOrchestrationLaunch,
  'organization-corporate': IconOrganizationCorporate,
  'overflow-horizontal': IconOverflowHorizontal,
  pause: IconPause,
  paused: IconPaused,
  'pencil-edit': IconPencilEdit,
  photo: IconPhoto,
  play: IconPlay,
  'privacy-open': IconPrivacyOpen,
  'python-logo': IconPythonLogo,
  'pytorch-lightning-logo': IconPytorchLightningLogo,
  'pytorch-logo': IconPytorchLogo,
  queue: IconQueue,
  queued: IconQueued,
  'randomize-alt': IconRandomizeAlt,
  'recent-clock': IconRecentClock,
  'reddit-social': IconRedditSocial,
  report: IconReport,
  retry: IconRetry,
  'robot-service-member': IconRobotServiceMember,
  'rocket-launch': IconRocketLaunch,
  run: IconRun,
  'running-repeat': IconRunningRepeat,
  'scikit-logo': IconScikitLogo,
  search: IconSearch,
  settings: IconSettings,
  'settings-parameters': IconSettingsParameters,
  'share-export': IconShareExport,
  'share-with': IconShareWith,
  'shield-remove': IconShieldRemove,
  'show-visible': IconShowVisible,
  smoothing: IconSmoothing,
  sort: IconSort,
  'sort-ascending': IconSortAscending,
  'sort-descending': IconSortDescending,
  star: IconStar,
  'star-filled': IconStarFilled,
  stop: IconStop,
  stopped: IconStopped,
  'sweep-bayes': IconSweepBayes,
  'sweep-grid': IconSweepGrid,
  'sweep-random-search': IconSweepRandomSearch,
  'sweeps-alt': IconSweepsAlt,
  'sweeps-broom': IconSweepsBroom,
  'sweeps-broom-alt': IconSweepsBroomAlt,
  system: IconSystem,
  'system-chip': IconSystemChip,
  'system-chip-alt': IconSystemChipAlt,
  table: IconTable,
  tag: IconTag,
  'tensorflow-logo': IconTensorflowLogo,
  'text-language': IconTextLanguage,
  'text-language-alt': IconTextLanguageAlt,
  'trigger-alt': IconTriggerAlt,
  twitter: IconTwitter,
  'undeterminate-visibility': IconUndeterminateVisibility,
  'user-profile-personal': IconUserProfilePersonal,
  'versions-layers': IconVersionsLayers,
  'vertex-gcp': IconVertexGCP,
  'video-play': IconVideoPlay,
  wandb: IconWandb,
  warning: IconWarning,
  'x-axis': IconXAxis,
  'youtube-social': IconYoutubeSocial,
};

export interface IconProps {
  name: IconName;
  [x: string]: any;
}

export const Icon = ({name, ...props}: IconProps) => {
  const IconComponent: ElementType = ICON_NAME_TO_ICON[name];
  if (!IconComponent) {
    throw new Error(`Could not find icon ${name}`);
  }
  return <IconComponent {...props} />;
};
